import { Options, Vue } from 'vue-class-component';

import List from '@/pages/config/contact-type/list/list.vue';

@Options({
  name: 'contact-type',
  components: {
    'page-list': List,
  },
})
export default class ContactType extends Vue {
  public isIndexOnly() {
    return /^[/]?contact-type[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
